/* Coria · trecere UX sertar de filtre (dialog#cfd) · colectie + cautare.
   1) butonul vizibil „Filtre” (.cf-filter-btn) primeste numarul de filtre active (luat din .cfd-open__n, randat de tema)
      si nume accesibil; aria-haspopup/aria-controls/aria-expanded sincronizate cu dialogul;
   2) „Sterge tot” (linkul existent .cfd__clear) apare si in subsolul sertarului, langa „Vezi produsele”, cand sunt filtre active.
   Nicio logica de filtrare schimbata; niciun text nou in afara numelui accesibil. */
(function () {
  'use strict';
  if (window.__cfUxFiltre) return; window.__cfUxFiltre = 1;
  function run() {
    var dlg = document.getElementById('cfd');
    if (!dlg) return;
    var openers = [].slice.call(document.querySelectorAll('.cf-filter-btn, .cfd-open'));
    var nEl = document.querySelector('.cfd-open__n');
    var n = nEl ? parseInt(nEl.textContent, 10) || 0 : 0;
    openers.forEach(function (b) {
      b.setAttribute('aria-haspopup', 'dialog');
      b.setAttribute('aria-controls', 'cfd');
      if (b.classList.contains('cf-filter-btn') && n > 0 && !b.querySelector('.cf-uxf-n')) {
        var badge = document.createElement('b');
        badge.className = 'cf-uxf-n';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = n;
        b.appendChild(badge);
      }
      if (n > 0) {
        var t = (b.textContent || '').replace(/\d+/g, '').trim() || 'Filtre';
        b.setAttribute('aria-label', t + ', ' + n + (n === 1 ? ' activ' : ' active'));
      }
    });
    function sync() {
      var open = dlg.hasAttribute('open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    }
    sync();
    if (window.MutationObserver) new MutationObserver(sync).observe(dlg, { attributes: true, attributeFilter: ['open'] });

    var clear = dlg.querySelector('.cfd__active .cfd__clear');
    var foot = dlg.querySelector('.cfd__foot');
    if (clear && foot && !foot.querySelector('.cf-uxf-clear')) {
      var c = document.createElement('a');
      c.className = 'cf-uxf-clear';
      c.href = clear.getAttribute('href');
      c.textContent = clear.textContent.trim();
      foot.insertBefore(c, foot.firstChild);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
